import { CreateLinksModal, LeadCollectorTabHeader, exportLinksToExcel } from '@features/leadCollector';
import { Form, LEAD_COLLECTOR_STEPS } from '@entities/leadCollector';
import { UnstyledButton } from '@shared/ui/unstyled-button';
import { DownloadLinksIcon, EyeIcon, LinkIcon } from '@shared/assets/icons';
import { formatDate } from '@shared/libs/format-date';
import { colors } from '@shared/tokens/colors.stylex';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';
import { useState } from 'react';
import { useToast } from '@shared/hooks/useToast';
import { FormLink } from '@pages/event/api/useFetchEvent';

interface CreateLinksProps {
  setStep: (step: number) => void;
  form?: Form;
  refetchEvent?: () => void;
  hasGeneratedLinks?: boolean;
  onPreviewTemplate: (formId?: number) => void;
  setPrevStep: (step: number) => void;
  formLinks?: FormLink[] | null;
}

export const CreateLinks = ({
  setStep,
  form,
  refetchEvent,
  hasGeneratedLinks,
  onPreviewTemplate,
  setPrevStep,
  formLinks,
}: CreateLinksProps) => {
  const [isLinksModalOpen, setIsLinksModalOpen] = useState(false);
  const { showToast } = useToast();

  const descriptionContent = hasGeneratedLinks ? (
    <div {...stylex.props(styles.pageDescription)}>
      <span>После создания ссылок будет невозможно изменить шаблон сбора контактных данных участников</span>
    </div>
  ) : (
    <span {...stylex.props(styles.pageDescription)}>
      После создания ссылок будет невозможно изменить шаблон сбора контактных данных участников
    </span>
  );

  const handleViewForm = () => {
    setPrevStep(LEAD_COLLECTOR_STEPS.CREATE_LINKS);
    onPreviewTemplate(form?.id);
  };

  const handleDownloadLinks = async () => {
    if (!formLinks?.length) {
      showToast('Ошибка загрузки данных: ссылки еще не сформированы', 'error');
      return;
    }

    try {
      await exportLinksToExcel(formLinks);
    } catch (error) {
      console.error('Ошбика загрузки данных', error);
      showToast('Ошбика загрузки данных', 'error');
    }
  };

  return (
    <div {...stylex.props(styles.container)}>
      <LeadCollectorTabHeader
        title={hasGeneratedLinks ? 'Ссылки созданы' : 'Создать ссылки'}
        onChooseForm={() => setStep(LEAD_COLLECTOR_STEPS.CHOOSE_FORM)}
        isDisabledChooseForm={hasGeneratedLinks}
      />
      {descriptionContent}
      <div {...stylex.props(styles.formContainer)}>
        <div {...stylex.props(styles.form)}>
          <div {...stylex.props(styles.description)}>
            <span {...stylex.props(styles.name)}>{form?.name}</span>
            <span {...stylex.props(styles.date)}>{formatDate(form?.createdAt || '')}</span>
          </div>
        </div>

        <div {...stylex.props(styles.actions)}>
          <UnstyledButton onClick={handleViewForm}>
            <span {...stylex.props(styles.action, styles.watch)}>
              <EyeIcon color={colors.tertiaryText} /> Посмотреть
            </span>
          </UnstyledButton>

          <div {...stylex.props(styles.actionsRight)}>
            {hasGeneratedLinks && (
              <UnstyledButton onClick={handleDownloadLinks}>
                <span {...stylex.props(styles.action)}>
                  <DownloadLinksIcon color={colors.primaryText} /> Скачать файл ссылок
                </span>
              </UnstyledButton>
            )}

            <UnstyledButton onClick={() => setIsLinksModalOpen(true)}>
              <span {...stylex.props(styles.action, styles.actionAccent)}>
                <LinkIcon /> Создать ссылки
              </span>
            </UnstyledButton>
          </div>
        </div>
      </div>

      <CreateLinksModal
        active={isLinksModalOpen}
        onCreateLinks={() => setIsLinksModalOpen(false)}
        onClose={() => setIsLinksModalOpen(false)}
        refetchEvent={refetchEvent}
      />
    </div>
  );
};
